import { ThemeEvents, CartFormSubmittedEvent } from '@theme/events';

(function ProductQuickBuy() {
  'use strict';

  // Loaded globally from theme.liquid rather than a block {% javascript %} tag:
  // block JS only ships inside block-scripts.js when the block is server-rendered
  // on the page, but quick-buy forms can arrive purely client-side — e.g.
  // recommendation cards appended by product-ai-accessories.js through the
  // /recommendations/products route — so the interception must always be present.

  const SELECTORS = {
    FORM: '[data-cart-form-add]',
    SUBMIT_BUTTON: '[data-product-quick-buy]'
  };

  // Delegated on document (not bound per-form) so forms injected after load
  // are intercepted too.
  document.addEventListener('click', handleFormClick);
  document.addEventListener('submit', handleFormSubmit);

  document.addEventListener(ThemeEvents.cartUpdated, clearBusyState);
  document.addEventListener(ThemeEvents.cartErrored, clearBusyState);

  function handleFormClick(event) {
    if (event.target.closest(SELECTORS.FORM)) {
      event.stopPropagation();
    }
  }

  function handleFormSubmit(event) {
    const formElement = event.target.closest(SELECTORS.FORM);

    if (!formElement) return;

    event.preventDefault();
    event.stopPropagation();

    const submitButton = formElement.querySelector(SELECTORS.SUBMIT_BUTTON);

    if (submitButton) {
      submitButton.setAttribute('aria-busy', true);
    }

    document.dispatchEvent(new CartFormSubmittedEvent({
      formElement
    }));
  }

  function clearBusyState() {
    document.querySelectorAll(`${SELECTORS.FORM} ${SELECTORS.SUBMIT_BUTTON}`).forEach((button) => {
      button.removeAttribute('aria-busy');
    });
  }
})();
